import React from "react";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import MDDialog from "components/MDDialog";
import MDTextButton from "components/MDTextButton";
import MDButton from "components/MDButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmationDialog = ({
  dialogTitle,
  dialogOpen,
  onClose,
  action,
  buttonLabel,
  confirmationText,
  btnColor,
}) => {
  return (
    <MDDialog
      dialogTitle={dialogTitle}
      dialogOpen={dialogOpen}
      dialogClose={onClose}
      TransitionComponent={Transition}
      maxWidth="sm"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 3,
          paddingBottom: 1,
          background: "rgba(255, 255, 255, 0.85)",
          backdropFilter: "blur(10px)",
          boxShadow:
            "0 4px 20px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.05)",
        },
      }}
    >
      {/* Body */}
      <DialogContent
        dividers
        sx={{
          padding: "20px 24px",
          border: "none",
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              background:
                btnColor === "error"
                  ? "rgba(255, 0, 0, 0.1)"
                  : "rgba(255, 193, 7, 0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{ color: btnColor === "error" ? "red" : "orange" }}
            >
              !
            </Typography>
          </Box>

          <Typography
            variant="subtitle1"
            fontSize={16}
            fontWeight={500}
            textAlign="center"
          >
            {confirmationText || "Are you sure you want to delete this item?"}
          </Typography>
        </Box>
      </DialogContent>

      {/* Footer buttons */}
      <DialogActions sx={{ padding: "14px 20px" }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="flex-end"
          width="100%"
        >
          <MDTextButton onClick={onClose} sx={{ fontSize: 14 }}>
            Cancel
          </MDTextButton>

          <MDButton
            size="medium"
            variant="contained"
            color={btnColor || "primary"}
            onClick={action}
            sx={{ padding: "6px 20px", fontSize: 14, fontWeight: 600 }}
          >
            {buttonLabel || "Delete"}
          </MDButton>
        </Stack>
      </DialogActions>
    </MDDialog>
  );
};

export default ConfirmationDialog;
